import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增救援队伍
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyTeam/save',
        method: 'post',
        data
    })
}
//修改救援队伍
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyTeam/update',
        method: 'post',
        data
    })
}
//查询救援队伍列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyTeam/list',
        method: 'get',
        params
    })
}
//查询救援队伍
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyTeam/detail?id=' + id,
        method: 'get',
    })
}
//删除救援队伍
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyTeam/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}